import { isNil } from "lodash";

export const formatTabSwitcherTabTitle = (string, amount) => {
  if (isNil(amount)) {
    return `${string}`;
  }

  return `${string} (${amount})`;
};
